import React, { useState, useEffect } from 'react'
import { useHistory } from 'react-router-dom'
import { useForm, Controller } from 'react-hook-form'
import {
  Table,
  ButtonGroup,
  IconButton,
  Icon,
  Panel,
  Row,
  Form,
  Col,
  Grid,
  Avatar,
  Input,
  ControlLabel,
  Button,
  ButtonToolbar,
  CheckPicker,
  Toggle,
} from 'rsuite'
import pathname from '../../constants/pathname'
import AppContext from '../../context/AppContext'
import { getAllProject, getTest } from '../../redux/actions/dashboard'
import './styles.less'
import TablePagination from 'rsuite/lib/Table/TablePagination'
import TooltipButton from '../../components/buttons/TooltipButton'
import ConfirmWidget from '../confirm/ConfirmWidget'
import { isEmpty } from 'lodash-es'

export default function TableAllProject({
  schema,
  subName,
  single,
  onSingleSubmit = () => {},
  muti,
  onMutiSubmit,
  enableView,
  onView,
  onRemove,
  onReload,
  pagination,
  lengthMenu,
  loading,
  hiddenColStatus,
  searchRows,
  onSearchProject,
  showContractNo,
  showToggle,
  setting = false,
  ...props
}) {
  const { Column, HeaderCell, Cell } = Table
  const history = useHistory()
  const [selectList, setSelectList] = useState([])
  const [isError, setIsError] = useState(false)
  const [isShowConfirm, setIsShowConfirm] = useState(false)
  const [deleteObj, setDeleteObj] = useState({})
  const [displayLength, setDisplayLength] = useState(5)
  const [page, setPage] = useState(1)
  const contextValue = React.useContext(AppContext)
  const [tableData, setTableData] = useState([])
  const [inputValueCode, setInputValueCode] = useState('')
  const [inputValueName, setInputValueName] = useState('')
  const [contractNo, setContractNo] = useState('')
  const [projectStatus, setProjectStatus] = useState([])
  const [projectDepartment, setProjectDepartment] = useState([])
  const [showMyProject, setShowMyProject] = useState(0)
  const [checked, setChecked] = useState(false)

  const fs = localStorage.getItem('fontSize')

  useEffect(() => {
    if (pagination && typeof onReload !== 'function') {
      setTableData(getData())
    } else if (schema.values) {
      if (schema.header === 'โครงการที่รอกลั่นกรองทางวิชาการ') {
        let nvalue = []
        for (const index in schema.values) {
          nvalue.push({
            id: schema.values[index].id,
            projectVersionId: schema.values[index].id,
            code: schema.values[index].code,
            projectName: schema.values[index].support,
            type: {
              icon: schema.values[index].type.icon,
              label: schema.values[index].type.label,
            },
            date: schema.values[index].Budgeted,
          })
        }

        if (nvalue.length != schema.totalSize) {
          schema.totalSize = nvalue.length
        }
        setTableData(nvalue)
      } else {
        setTableData(schema.values)
      }
    } else {
      setTableData([])
    }
  }, [schema, pagination, onReload])

  const defaultPage = 1
  const defaultLengthMenu = [
    { value: 5, label: 5 },
    { value: 10, label: 10 },
    { value: 15, label: 15 },
  ]

  const getIcon = (key) => {
    if (key == 1) {
      return 'file-o'
    } else if (key == 2) {
      return 'copy-o'
    } else if (key == 3) {
      return 'building2'
    }
  }

  const handleChangeLength = (dataKey) => {
    // console.log('handleChangeLength dataKey', dataKey)
    setPage(1)
    setDisplayLength(dataKey)
    if (typeof onReload === 'function') {
      onReload(
        dataKey,
        1,
        inputValueCode,
        inputValueName,
        contractNo,
        projectStatus,
        projectDepartment,
        showMyProject
      )
    }
  }

  const handleChangePage = (dataKey) => {
    // console.log('handleChangePage page', dataKey)

    setPage(dataKey)
    if (typeof onReload === 'function') {
      onReload(
        displayLength,
        dataKey,
        inputValueCode,
        inputValueName,
        contractNo,
        projectStatus,
        projectDepartment,
        showMyProject
      )
    }
  }

  const getData = () => {
    return schema.values?.filter((v, i) => {
      const start = displayLength * (page - 1)
      const end = start + displayLength
      return i >= start && i < end
    })
  }

  const handleChangeProjectCode = (val) => {
    setInputValueCode(val)
  }

  const handleChangeProjectName = (val) => {
    setInputValueName(val)
  }

  const handleChangeContractNo = (val) => {
    setContractNo(val)
  }

  const handleSearchProject = () => {
    onSearchProject(
      5,
      1,
      inputValueCode,
      inputValueName,
      contractNo,
      projectStatus,
      projectDepartment,
      showMyProject
    )
    setPage(1)
  }

  const handleCancelSearchProject = () => {
    setInputValueCode('')
    setInputValueName('')
    setContractNo('')
    setProjectStatus(null)
    setProjectDepartment(null)
    setChecked(false)
    onSearchProject(5, 1, '', '', '', [], [], 0)
    setPage(1)
    handleChangeToggle(false)
  }

  const SubnameCell = ({ rowData, dataKey, ...props }) => {
    let _color = '#ff9800'
    // if (schema.header === 'โครงการทั้งหมด') {
    //   _color = '#ff0000'
    // } else {
    //   _color = '#ff9800'
    // }

    return (
      <Cell {...props}>
        <Grid fluid>
          <Row>
            <Col lg={24} md={24} sm={24} xs={24}>
              {rowData[dataKey].name || rowData[dataKey]}
            </Col>
            <Col lg={24} md={24} sm={24} xs={24} style={{ fontSize: 12, color: _color }}>
              {rowData[dataKey].statusName && (
                <>
                  <Icon icon="exclamation-circle2" size="lg" />
                  &nbsp;&nbsp;
                  {rowData[dataKey].statusName}
                </>
              )}
            </Col>
          </Row>
        </Grid>
      </Cell>
    )
  }

  const ImageCell = ({ rowData, dataKey, ...props }) => (
    <Cell {...props} /*style={{ padding: 0, marginTop: 8 }}*/>
      <Grid fluid>
        <Row>
          <Col
            lg={8}
            md={8}
            sm={8}
            xs={8}
            style={{
              // width: 32,
              // height: 32,
              width: '2.5rem',
              height: '2.5rem',
              background: contextValue.theme[0] == 'dark' ? '#515151' : '#f0f0f0',
              borderRadius: 20,
              marginTop: 2,
              overflow: 'hidden',
              display: 'inline-block',
              textAlign: 'center',
            }}
          >
            <Icon icon={rowData[dataKey].icon} size={'lg'} style={{ marginTop: 10 }} />
          </Col>
          <Col lg={16} md={16} sm={16} xs={16} style={{ marginTop: 10 }}>
            {rowData[dataKey].label || rowData[dataKey].projectType}
          </Col>
        </Row>
      </Grid>
    </Cell>
  )

  const TagCell = ({ rowData, dataKey, ...props }) => {
    return (
      <Cell {...props} /*style={{ padding: 13 }}*/>
        <div
          className="tag"
          style={{
            backgroundColor: rowData[dataKey].code || '',
            height: '100%',
          }}
        >
          <span className="tag__text">{rowData[dataKey].label}</span>
        </div>
      </Cell>
    )
  }

  const handleChangeToggle = (val) => {
    console.log('handleChangeToggle ', val)
    setChecked(val)
    setShowMyProject(val ? 1 : 0)
  }

  return (
    <>
      <Panel
        header={schema?.header}
        bordered
        collapsible
        shaded
        // defaultExpanded={!isEmpty(schema?.values)}
        defaultExpanded
        className="table-all-project"
        style={{ marginTop: 15 }}
      >
        {searchRows?.enable && (
          <Grid fluid>
            <Row gutter={16}>
              <Col lg={5} md={12} sm={24} xs={24}>
                <ControlLabel>รหัสโครงการ</ControlLabel>
                <Input
                  name={'projectcode'}
                  value={inputValueCode}
                  placeholder="ระบุรหัสโครงการ"
                  onChange={handleChangeProjectCode}
                  disabled={setting}
                ></Input>
              </Col>
              <Col lg={5} md={12} sm={24} xs={24}>
                <ControlLabel>ชื่อโครงการ</ControlLabel>
                <Input
                  name={'projectname'}
                  value={inputValueName}
                  placeholder="ระบุชื่อโครงการ"
                  onChange={handleChangeProjectName}
                  disabled={setting}
                ></Input>
              </Col>
              {searchRows?.enableContract && (
                <Col lg={5} md={12} sm={24} xs={24}>
                  <ControlLabel>เลขที่ข้อตกลง</ControlLabel>
                  <Input
                    name={'contractNo'}
                    value={contractNo}
                    placeholder="ระบุเลขที่ข้อตกลง"
                    onChange={handleChangeContractNo}
                    disabled={setting}
                  ></Input>
                </Col>
              )}

              {searchRows?.enableProjectStatus &&
                schema?.projectStatusOption &&
                !schema?.projectStatusOption?.disabled && (
                  <Col lg={5} md={12} sm={24} xs={24}>
                    <ControlLabel>{schema.projectStatusOption.label}</ControlLabel>
                    <CheckPicker
                      sticky
                      data={schema.projectStatusOption.options}
                      value={projectStatus}
                      block
                      placeholder="เลือก"
                      onChange={(value) => {
                        // console.log('x => ', value)
                        setProjectStatus(value)
                      }}
                      disabled={setting}
                    />
                  </Col>
                )}

              {searchRows?.enableProjectdepartment &&
                schema?.departmentOption &&
                !schema?.departmentOption?.disabled && (
                  <Col lg={5} md={12} sm={24} xs={24}>
                    <ControlLabel>{schema.departmentOption.label}</ControlLabel>
                    <CheckPicker
                      sticky
                      data={schema.departmentOption.options}
                      value={projectDepartment}
                      block
                      placeholder="เลือก"
                      onChange={(value) => {
                        // console.log('x => ', value)
                        setProjectDepartment(value)
                      }}
                      disabled={setting}
                    />
                  </Col>
                )}

              {searchRows?.enableToggle && schema?.showMyProject?.disabled && (
                <>
                  <Col lg={5} md={12} sm={24} xs={24}>
                    <ControlLabel></ControlLabel>
                    <div style={{ marginTop: 25 }}>
                      <Toggle
                        size="md"
                        checked={checked}
                        checkedChildren={<Icon icon="check" />}
                        unCheckedChildren={<Icon icon="close" />}
                        onChange={handleChangeToggle}
                        disabled={setting}
                      />{' '}
                      <b>{schema.showMyProject.label}</b>
                    </div>
                  </Col>
                </>
              )}

              <Col lg={5} md={12} sm={24} xs={24}>
                <div>
                  <br />
                  <IconButton
                    appearance="ghost"
                    size="md"
                    icon={<Icon appearance="ghost" icon="search" className="bt-gost-icon-radius" />}
                    style={{
                      marginBottom: '10px',
                      marginRight: '10px',
                      width: '45%',
                      // height: '35px',
                    }}
                    onClick={handleSearchProject}
                    disabled={setting}
                  >
                    ค้นหา
                  </IconButton>
                  <IconButton
                    appearance="ghost"
                    className="rs-btn-ghost-edit"
                    size="md"
                    icon={
                      <Icon
                        appearance="ghost"
                        icon="close-circle"
                        className="bt-gost-icon-radius-edit"
                      />
                    }
                    style={{ marginBottom: '10px', width: '45%' }}
                    onClick={handleCancelSearchProject}
                    disabled={setting}
                  >
                    ยกเลิก
                  </IconButton>
                </div>
              </Col>
            </Row>
          </Grid>
        )}

        {/* {tableData?.length < 1 ? (
          <div>{`-- ไม่พบข้อมูล ${schema?.header || ''} --`}</div>
        ) : (
          <> */}
        <Table
          wordWrap
          // height={!isEmpty(schema?.values) ? 100 : 400}
          autoHeight={setting}
          height={400}
          loading={loading}
          data={tableData}
          style={{ marginTop: '20px' }}
        >
          <Column align="center" width={(fs || 1) < 18 ? 120 : 140}>
            <HeaderCell>
              <span>{schema.projectCodeText}</span>
            </HeaderCell>
            <Cell dataKey="code" />
          </Column>

          {subName?.enable ? (
            <Column minWidth={500} flexGrow={1}>
              <HeaderCell>
                <span>{schema.projectNameText}</span>
              </HeaderCell>
              <SubnameCell dataKey="projectName" />
            </Column>
          ) : (
            <Column minWidth={500} flexGrow={1}>
              <HeaderCell>
                <span>{schema.projectNameText}</span>
              </HeaderCell>
              <Cell dataKey="projectName" />
            </Column>
          )}

          {schema.projectTypeText && (
            <Column width={(fs || 1) < 18 ? 160 : 190}>
              <HeaderCell>
                <span>{schema.projectTypeText}</span>
              </HeaderCell>
              <ImageCell dataKey="type" />
            </Column>
          )}

          {hiddenColStatus && (
            <Column width={(fs || 1) < 18 ? 160 : 190} align={'center'}>
              <HeaderCell>
                <span>{schema.projectStatusText}</span>
              </HeaderCell>
              <TagCell dataKey="colorstatus" />
            </Column>
          )}

          <Column width={(fs || 1) < 18 ? 220 : 240}>
            <HeaderCell>
              <span>{schema.projectEditVerText}</span>
            </HeaderCell>
            <Cell dataKey="date" />
          </Column>

          {showContractNo && (
            <Column width={140}>
              <HeaderCell>
                <span>เลขที่ข้อตกลง</span>
              </HeaderCell>
              <Cell dataKey="contractNo" />
            </Column>
          )}

          <Column width={120} align="center" fixed="right">
            <HeaderCell>
              <span></span>
            </HeaderCell>
            <Cell>
              {(rowData) => {
                return (
                  <ButtonToolbar>
                    <IconButton
                      size="lg"
                      appearance="ghost"
                      icon={<Icon icon="eye" className="bt-gost-icon-radius" />}
                      onClick={() => {
                        onSingleSubmit(rowData.projectVersionId)

                        // history.push({
                        //   pathname: `${pathname.proposal.overview.overviewCoworker}/${rowData.projectVersionId}`,
                        // })
                      }}
                      disabled={setting}
                    >
                      แสดง
                    </IconButton>
                  </ButtonToolbar>

                  // <ButtonGroup appearance="ghost">
                  //   <IconButton
                  //     icon={<Icon icon="eye" />}
                  //     onClick={() => {
                  //       history.push({
                  //         pathname: `${pathname.proposal.overview.overviewCoworker}/${rowData.projectVersionId}`,
                  //       })
                  //     }}
                  //   >
                  //     แสดง
                  //   </IconButton>
                  // </ButtonGroup>
                )
              }}
            </Cell>
          </Column>
        </Table>

        {pagination && (
          <TablePagination
            lengthMenu={lengthMenu || defaultLengthMenu}
            activePage={page || defaultPage}
            renderLengthMenu={(lengthMenu) => {
              return (
                <>
                  {lengthMenu}
                  {`รายการ/หน้า`}
                </>
              )
            }}
            renderTotal={(total) => {
              return <>{` ทั้งหมด ${total || 0} รายการ`}</>
            }}
            displayLength={displayLength || 5}
            total={schema.totalSize}
            onChangePage={handleChangePage}
            onChangeLength={handleChangeLength}
          />
        )}

        {schema?.message && (
          <Row>
            <Message showIcon type={schema.message.type} description={schema.message.message} />
          </Row>
        )}

        {muti?.enable && (
          <>
            {isError && (
              <Row style={{ marginTop: 10 }}>
                <Message
                  showIcon
                  type="error"
                  description="กรุณาเลือกอย่างน้อย 1 โครงการ"
                ></Message>
              </Row>
            )}
            <IconButton
              icon={<Icon icon="filter" />}
              style={{ float: 'right', marginBottom: 20, marginTop: 10 }}
              onClick={() => {
                if (selectList && selectList.length < 1) {
                  setIsError(true)
                } else {
                  onMutiSubmit(selectList)
                  setSelectList([])
                }
              }}
            >
              {muti?.buttonText || ''}
            </IconButton>
          </>
        )}
        {/* </>
        )} */}

        <ConfirmWidget
          title={`ยืนยันการลบรายการ`}
          show={isShowConfirm}
          detail={`ยืนยันการลบ ${
            deleteObj?.projectName ? schema.projectNameText + ' : ' + deleteObj.projectName : ''
          }`}
          onCancle={() => {
            setIsShowConfirm(false)
            setDeleteObj({})
          }}
          onConfirm={() => {
            onRemove(deleteObj)
            let total = schema.values.length
            let newPage = Math.ceil(total / displayLength)
            if (newPage > 0 && newPage < page) {
              setPage(newPage)
            }
            setIsShowConfirm(false)
          }}
        />
      </Panel>
    </>
  )
}
